import { Form } from "react-bootstrap";

function FormRow({ children, label, error, optional }) {
  return (
    <Form.Group className="pb-3">
      {label && (
        <Form.Label className="fw-bold" htmlFor={children.props.id}>
          {label}
          {optional && <span className="fs-6 px-2 fw-lighter text-secondary">*optional</span>}
        </Form.Label>
      )}
      {children}
      {error && <div className="pt-2 text-danger">{error}</div>}
    </Form.Group>
  );
}

export default FormRow;
